import React from 'react'
import Hero from './hero'
import '../App.css'
import Banner from './banner'
import { Link } from 'react-router-dom'
import Services from './sevices'
import FeaturedRooms from './featuredRooms'
// import Header from '../components/styledHero'
function Home() {
    return (
        <>
            <Hero>
                <Banner title='Luxurious rooms' subtitle='Deluxe rooms starting at $299'>
                    <Link to='/rooms' className='btn-primary'>
                        Our Rooms
                    </Link>
                </Banner>
            </Hero>
            <Services />
            <FeaturedRooms />

            {/* <Header >hello yo</Header> */}
        </>
    )
}

export default Home
